import { Card, Container, Image, Row, Col, Badge } from "react-bootstrap";
import myAvatar from "../images/myAvatar.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCss3Alt,
  faGithub,
  faHtml5,
  faLinkedin,
  faReact,
  faSass,
  faNodeJs,
} from "@fortawesome/free-brands-svg-icons";
import { faDatabase } from "@fortawesome/free-solid-svg-icons";
const Home = () => {
  return (
    <Container className="home__container" id="home">
      <Card className="card__container">
        <Row>
          <Col className="d-flex align-items-center">
            <Card.Body>
              <Card.Title className="card__title">
                Full Stack Developer
              </Card.Title>
              <Card.Text className="home__paragraph">
                Welcome to my portfolio! I'm Vincenzo Chiovaro, a full-stack
                developer based in Manchester🐝
              </Card.Text>
              <p>
                <a
                  className="icons__text"
                  rel="noreferrer"
                  target={"_blank"}
                  href="https://github.com/vincenzochiovaro"
                >
                  <FontAwesomeIcon icon={faGithub} /> GitHub
                </a>
                <span>&nbsp;&nbsp;</span>
                <a
                  className="icons__text"
                  rel="noreferrer"
                  target={"_blank"}
                  href="https://www.linkedin.com/in/vincenzo-chiovaro-22258a176/"
                >
                  <FontAwesomeIcon icon={faLinkedin} /> LinkedIn
                </a>
                <Image src={myAvatar} alt="Avatar" className="avatar__mobile" />
              </p>
            </Card.Body>
          </Col>
          <Col className="d-flex align-items-center">
            <Image src={myAvatar} alt="Avatar" className="avatar" />
          </Col>
        </Row>
        <Row>
          <Col>
            <section className="tech-stack__container">
              <Badge bg="light" text="dark" className="tech-stack-badge">
                Tech Stack
              </Badge>
              <div className="tech-stack-icons">
                <FontAwesomeIcon
                  icon={faHtml5}
                  aria-label="HTML icon"
                  color="#E44D26"
                  size="2x"
                  className="mx-3"
                  data-testid="html-icon"
                />
                <FontAwesomeIcon
                  icon={faCss3Alt}
                  aria-label="CSS icon"
                  color="#264DE4"
                  size="2x"
                  className="mx-3"
                  data-testid="css-icon"
                />
                <FontAwesomeIcon
                  icon={faNodeJs}
                  aria-label="Node Javascript icon"
                  size="2x"
                  color="#339933"
                  className="mx-3"
                  data-testid="node-icon"
                />
                <FontAwesomeIcon
                  icon={faReact}
                  aria-label="React icon"
                  color="#61DBFB"
                  size="2x"
                  className="mx-3"
                  data-testid="react-icon"
                />
                <FontAwesomeIcon
                  icon={faDatabase}
                  aria-label="PostgreSQL icon"
                  color="#336791"
                  size="2x"
                  className="mx-3"
                  data-testid="postgres-icon"
                />
                <FontAwesomeIcon
                  icon={faSass}
                  aria-label="Sass icon"
                  size="2x"
                  color="#CD6799"
                  className="mx-3"
                  data-testid="sass-icon"
                />
              </div>
            </section>
          </Col>
        </Row>
      </Card>
    </Container>
  );
};

export default Home;
